import { format } from 'date-fns';
import { Event } from '../../model/event';
import { PictureDays } from '../../model/picture-days';

export const dateFormatter = (eventDetails: Event | undefined) => {
  let formattedDates: string | Date[][] = [];
  const dates: Date[] | undefined = eventDetails?.pictureDays?.map(
    (it: PictureDays) => new Date(it.pictureDayDate?.replace(/-/g, '/')!)
  );

  dates?.sort((x: Date, y: Date) => +x - +y);

  let start = dates?.[0];
  let end = dates?.[0];
  let range: Date[] = [start!, end!];

  for (let i = 0; i < dates?.length! - 1; i++) {
    if (dates![i + 1].getMonth() === dates![i].getMonth() && dates![i + 1].getDate() - dates![i].getDate() <= 1) {
      end = dates![i + 1];
      range = [start!, end];
    } else {
      formattedDates = [...formattedDates!, range];
      start = dates![i + 1];
      end = dates![i + 1];
      range = [start, end];
    }
  }

  formattedDates = [...formattedDates, range]
    ?.map((date: Date[]) => {
      if (date.length === 1 || date[0] === date[1]) {
        return date[0] ? format(date[0], 'MMMM d, yyyy') : '';
      }

      if (date.length === 2) {
        return format(date[0], 'MMMM d ') + '-' + format(date[1], ' d, yyyy');
      }

      return '';
    })
    .join(', ');

  return formattedDates;
};

export const toSlashedDate = (inDate: string): string => {
  try {
    const dateParts = inDate.split('-').map((str) => parseInt(str));
    const date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
    return format(date, 'M/d/yyyy');
  } catch (e: any) {
    console.error(`Failed to convert date ${inDate}: ${e.message}`);
    return 'DATE ERROR';
  }
};

export const formattedZoneTime = (date?: string, onlyTime = false) => {
  try {
    if (!date) {
      return undefined;
    }
    const dateString = new Date(date + 'Z').toLocaleTimeString([], {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });

    //get time zone code
    const regExp = /\(([^)]+)\)/;
    const currentZoneTime = new Date(date + 'Z').toTimeString();
    const matches = regExp.exec(currentZoneTime);
    const timeZone = matches![1]
      .split(' ')
      .map((word) => word[0])
      .join('');

    if (onlyTime) {
      return dateString.split(',')[1].trim()
    }
    return dateString + ' ' + timeZone;
  } catch (e: any) {
    console.error(`Failed to format date: ${e.message}`);
    return 'DATE ERROR';
  }
};
